const DEFAULT_HELP_MESSAGE = "Reply STOP to opt out. Msg&Data Rates May Apply";
const DEFAULT_STOP_MESSAGE = "You have successfully opted out and will no longer receive messages";

export default {

    helpMessage({registrationResponse, mainAccountRegistrationResponse}) {
        return (
            (registrationResponse?.message_content_page?.helpMessage || mainAccountRegistrationResponse?.message_content_page?.helpMessage) ?? DEFAULT_HELP_MESSAGE
        );
    },
    stopMessage({registrationResponse, mainAccountRegistrationResponse}) {
        return (
            (registrationResponse?.message_content_page?.stopMessage || mainAccountRegistrationResponse?.message_content_page?.stopMessage) ?? DEFAULT_STOP_MESSAGE
        );
    },
    optInMessage({registrationResponse, mainAccountRegistrationResponse}) {
        return (
            registrationResponse?.vonage_api_campaign_request?.opt_in_message ||
            mainAccountRegistrationResponse?.vonage_api_campaign_request?.opt_in_message
        );
    },
    registrationResponse({registrationResponse}) {
        return registrationResponse
    },
}
